var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "nature"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2191_1068",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 34
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 34,
    height: 34,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2191_1068)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "nature_2",
    d: "M7.08464 31.1663V28.333H15.5846V22.6663H12.7513C10.7916 22.6663 9.12109 21.9757 7.73984 20.5945C6.35859 19.2132 5.66797 17.5427 5.66797 15.583C5.66797 14.1663 6.05755 12.8618 6.83672 11.6695C7.61589 10.4771 8.66658 9.6094 9.9888 9.06634C10.2013 7.29551 10.9746 5.81391 12.3086 4.62155C13.6426 3.42919 15.2069 2.83301 17.0013 2.83301C18.7957 2.83301 20.36 3.42919 21.694 4.62155C23.028 5.81391 23.8013 7.29551 24.0138 9.06634C25.336 9.6094 26.3867 10.4771 27.1659 11.6695C27.9451 12.8618 28.3346 14.1663 28.3346 15.583C28.3346 17.5427 27.644 19.2132 26.2628 20.5945C24.8815 21.9757 23.211 22.6663 21.2513 22.6663H18.418V28.333H26.918V31.1663H7.08464ZM12.7513 19.833H21.2513C22.4319 19.833 23.4353 19.4198 24.2617 18.5934C25.0881 17.767 25.5013 16.7636 25.5013 15.583C25.5013 14.733 25.2593 13.9538 24.7753 13.2455C24.2912 12.5372 23.6596 12.0177 22.8805 11.6872L21.393 11.0497L21.1805 9.42051C21.0388 8.35801 20.5725 7.46669 19.7815 6.74655C18.9905 6.02641 18.0638 5.66634 17.0013 5.66634C15.9388 5.66634 15.0121 6.02641 14.2211 6.74655C13.4301 7.46669 12.9638 8.35801 12.8221 9.42051L12.6096 11.0497L11.1221 11.6872C10.343 12.0177 9.71137 12.5372 9.22734 13.2455C8.74332 13.9538 8.5013 14.733 8.5013 15.583C8.5013 16.7636 8.9145 17.767 9.74089 18.5934C10.5673 19.4198 11.5707 19.833 12.7513 19.833Z",
    fill: "#FE6728"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNature);
export default __webpack_public_path__ + "static/media/nature.cc92102ba5a6ec06477795d8b21cd00a.svg";
export { ForwardRef as ReactComponent };